module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/svgs/regular/address-book.svg?2851163601507d5c6351af439cc89598";